function getSortKey(duration) {
  var order = [
    "Day",
    "Days",
    "Week",
    "Weeks",
    "Month",
    "Months",
    "Year",
    "Years",
  ];

  if (!duration) {
    console.warn("Missing data-plan-duration attribute for an option.");
    return { index: order.length, number: 0 };
  }

  var normalizedDuration = duration.replace(/\b\w/g, (char) =>
    char.toUpperCase()
  );

  var keyIndex = order.length;
  for (var key of order) {
    if (normalizedDuration.includes(key)) {
      keyIndex = order.indexOf(key);
      break;
    }
  }

  var numberMatch = normalizedDuration.match(/\d+/);
  var number = numberMatch ? parseInt(numberMatch[0], 10) : 0;

  return { index: keyIndex, number: number };
}

function sortSelectOptions(optgroupElement) {
  var options = Array.from(optgroupElement.querySelectorAll("option"));

  options.sort(function (optionOne, optionTwo) {
    var optionOneData = getSortKey(
      optionOne.getAttribute("data-plan-duration")
    );
    var optionTwoData = getSortKey(
      optionTwo.getAttribute("data-plan-duration")
    );

    if (optionOneData.index !== optionTwoData.index) {
      return optionOneData.index - optionTwoData.index;
    }
    return optionOneData.number - optionTwoData.number;
  });

  optgroupElement.innerHTML = "";

  options.forEach(function (option) {
    optgroupElement.appendChild(option);
  });
}

function processSubscriptionList() {
  var rebuySubscriptionList = document.querySelectorAll(
    ".rebuy-select--subscription.giant-coloring-sheets"
  );

  if (rebuySubscriptionList.length > 0) {
    rebuySubscriptionList.forEach((subBox) => {
      if (subBox) {
        var selectedOptionList = subBox.querySelector(
          "optgroup.rebuy-select--subscription-optgroup"
        );
        if (selectedOptionList) {
          sortSelectOptions(selectedOptionList);
        }
      }
    });
  }
}

document.addEventListener("rebuy:smartcart.ready", async (event) => {
  const imageBlock = document.getElementById("rebuy-cart__outside-step-image");
  const freeTitleBlock = document.getElementById(
    "rebuy-cart__outside-step-title"
  );
  const progressStep = document.querySelectorAll(".rebuy-cart__progress-step");

  if (progressStep.length > 0) {
    progressStep.forEach((element) => {
      let innerStep = element.querySelector(".rebuy-cart__progress-step-icon");

      if (
        innerStep &&
        innerStep.querySelector(".rebuy-cart__progress-step-icon-image")
      ) {
        imageBlock.innerHTML = innerStep.innerHTML;

        let productTitle = element.querySelector(
          ".rebuy-cart__progress-step-info"
        );
        freeTitleBlock.innerText = productTitle.innerText;

        productTitle.innerText = "20% off + Free Gift";
      }
    });
  }

  processSubscriptionList();
});

function getCorrectApiUrl() {
  return "/?sections=cart-obj&skipCache"; // Ensure this never changes
}

document.addEventListener("rebuy:cart.change", async (event) => {
  let apiUrlStatic = getCorrectApiUrl();
  const current_market = document.querySelector("#current_market").value;

  if (current_market && current_market == "canada")
    apiUrlStatic = "en-ca" + apiUrlStatic;

  const cartId = "rebuy-cart-template";
  const checkId = document.querySelector("#" + cartId);
  try {
    const response = await fetch(apiUrlStatic)
      .then((response) => response.json())
      .then((data) => {
        const elementId = "myNotification";
        //const cartItemCount = 'cartItemCount';
        const cartPriceSection = ".cartPriceSection";
        //const cartFooterSection = 'rebuy-main-cart-footer';
        let cartObjHTML = data["cart-obj"];
        const parser = new DOMParser();
        cartObjHTML = parser.parseFromString(cartObjHTML, "text/html");
        if (cartObjHTML.getElementById(elementId) !== null) {
          const fetchedContent =
            cartObjHTML.getElementById(elementId).innerHTML;

          if (fetchedContent != "") {
            const notificationAreaVTwo = document.getElementById("progressNotification");
            const notificationAreaVThree = document.getElementById("progressNotificationThree");
            if(notificationAreaVTwo) {
              notificationAreaVTwo.innerHTML = fetchedContent;
            } else if(notificationAreaVThree) {
              notificationAreaVThree.innerHTML = fetchedContent;
            } else {
              const contentArea = document.querySelector(
                ".rebuy-cart__progress-bar-wrapper"
              );
              if (contentArea) contentArea.innerHTML = fetchedContent;
            }
          } else {
            document
              .getElementById("rebuy-cart__progress-bar-wrapper")
              .classList.add("d-none");
          }
        }

        // cart item count update
        const cartIcons = document.querySelector(".header__icons .cart-count-bubble");
        const updatedItemCount = Rebuy.SmartCart?.itemCount() ?? '0';
        const insideBubble = '<span aria-hidden="true">'+updatedItemCount+'</span><span class="visually-hidden">'+updatedItemCount+' items</span>';

        if(cartIcons){
          cartIcons.innerHTML = insideBubble;
        }

        // cart price update
        if (cartObjHTML.querySelectorAll(cartPriceSection).length > 0) {
          //console.log("Inside cartPriceSection: "+cartObjHTML.querySelectorAll(cartPriceSection));
          cartObjHTML
            .querySelectorAll(cartPriceSection)
            .forEach(function (priceSection) {
              var rebuyPrice = priceSection.innerHTML;
              var rebuyItem = document.querySelectorAll(
                ".rebuy-cart__flyout-item"
              );
              //console.log("Ayaz length: "+rebuyItem.length);
              if (rebuyItem.length > 0) {
                var iCount = 1;
                rebuyItem.forEach(function (item) {
                  //console.log("===========");
                  //console.log(priceSection.getAttribute("data-product-id")+'------'+item.getAttribute("data-product-id")+iCount);
                  if (
                    priceSection.getAttribute("data-product-id") ==
                    item.getAttribute("data-product-id") + iCount
                  ) {
                    const rebuyPriceSection = item.querySelector(
                      ".rebuy-cart__flyout-item-price"
                    );
                    //console.lgo("Price: "+rebuyPrice);
                    if (rebuyPriceSection)
                      rebuyPriceSection.innerHTML = rebuyPrice;
                  }
                  iCount++;
                });
              }
            });
        }
      });
  } catch (error) {
    console.error("There was a problem with the fetch operation:", error);
  }
});
